import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import { clearFormInput, formError, formInput } from 'actions/FormActions';
import { getOnlineOrderDetails, getProductByBarcode, generateOrderBasedOnlineOrder, getStoreToDoorPickupTime, getManagerApproval } from 'actions/EntityActions';
import BarcodeReader from 'library/readBarcode';
import util from 'library/util';
import { showError } from 'actions/CommonActions';
import WithRouter from 'custom/withRouter';
// Basic Components
import Button from 'screens/components/basic/Button';
import CardSimple from 'screens/components/basic/CardSimple';
import SelectInputQueuedOrderPrepare from 'screens/components/basic/SelectInputQueuedOrderPrepare';
import Grid from 'screens/components/basic/Grid';
import DatePickerInput from 'screens/components/basic/DatePickerInput';
import SelectInput from 'screens/components/basic/SelectInput';
import DialogInput from 'screens/components/advanced/DialogInput';
import TextInput from 'screens/components/basic/TextInput';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';

class OnlineOrderPrepare extends Component {

    constructor(props) {
        super(props);
        this.state = {
            onlineOrderSelected: null,
            splitedOnlineOrderProducts: [],
            managerApprovalDialogOpened: false,
            managerApproved: false
        }
        this.barcodeReader = new BarcodeReader();

        this.updateProductToScanned = this.updateProductToScanned.bind(this);
    }

    componentWillMount() {
        this.props.getOnlineOrderDetails(this.props.params.id);
        this.props.formInput(moment(new Date()).format('YYYY-MM-DD'), 'StoreToDoorPickupDate')
    }

    componentWillReceiveProps(newProps) {
        if (this.state.onlineOrderSelected !== newProps.onlineOrderSelected && newProps.onlineOrderSelected !== null && newProps.onlineOrderSelected !== undefined) {
            //store to door activated
            if (newProps.onlineOrderSelected && newProps.onlineOrderSelected.deliveryType == 2) {
                this.props.getStoreToDoorPickupTime(this.props.branchId, this.props.selectedPickupDate);
            }

            this.setState({ onlineOrderSelected: newProps.onlineOrderSelected });

            let splitedOnlineOrderProducts = [];
            if (newProps.onlineOrderSelected && newProps.onlineOrderSelected.products.length > 0) {
                newProps.onlineOrderSelected.products.forEach(p => {
                    for (let i = 0; i < p.quantity; i++) {
                        let ExistMoreThanOneLotNumbers = [];
                        if (p.lotNumbers && p.lotNumbers.length > 0) {
                            ExistMoreThanOneLotNumbers.push({ text: "select lot # if can not scan", value: "0" });
                            p.lotNumbers.map(item => {
                                ExistMoreThanOneLotNumbers.push({
                                    text: item,
                                    value: item
                                })
                            });
                        }
                        splitedOnlineOrderProducts.push({
                            id: p.id,
                            productId: p.productId,
                            product: p.product,
                            isCannabis: p.isCannabis,
                            price: p.price,
                            quantity: 1,
                            total: p.total,
                            scanned: false,
                            lotNumber: '',
                            ExistMoreThanOneLotNumbers: ExistMoreThanOneLotNumbers
                        })
                    }
                });
            }

            this.setState({ splitedOnlineOrderProducts: splitedOnlineOrderProducts });
        }


        //Get Product By Barcode
        if (this.props.scannedTime !== newProps.scannedTime && newProps.scannedTime != null && newProps.scannedTime != undefined) {
            //Checking if the scanned product is on the online order
            let itemScan = this.state.onlineOrderSelected.products.filter(p => p.productId == newProps.productScan.id);
            if (itemScan !== null && itemScan !== undefined && itemScan.length > 0) {
                //Checking the quantity on the Warehouse
                if (itemScan[0].quantity <= newProps.productScan.packages[0].quantity || this.props.fulfillmentEnabled) {
                    //Updating the list of scanned products
                    let lotNumber = newProps.productScan.packages[0].packageReference;

                    let scannedIndex = this.state.splitedOnlineOrderProducts.findIndex(e => e.productId == newProps.productScan.id && e.scanned == false);
                    // if the product is already scanned, show error dialog
                    if (scannedIndex == -1) {
                        this.props.showError("This product has already been scanned, please double check.");
                        return;
                    }
                    let newArray = [...this.state.splitedOnlineOrderProducts];
                    newArray[scannedIndex] = { ...newArray[scannedIndex], scanned: true, lotNumber: lotNumber }
                    this.setState({ splitedOnlineOrderProducts: newArray });
                } else {
                    this.props.showError("The product is no stock available for the lot number scanned.");
                }
            } else {
                this.props.showError("The product is not added on the Online Order.");
            }
        }

        //Get the barcode scan result
        if (newProps.barcodeNotFound && newProps.barcodeNotFound != this.props.barcodeNotFound) {
            this.props.showError("Product was not found. Check if the product is available for sale or if it is out of stock.");
        }

        //Get the generated POS Sale
        if (newProps.generatedOrderId !== null && newProps.generatedOrderId !== undefined && newProps.generatedOrderId !== this.props.generatedOrderId) {
            this.props.navigate("/pos/" + newProps.generatedOrderId);
            window.location.reload();
        }

        if (newProps.generateOrderErrorTime !== null && newProps.generateOrderErrorTime !== undefined && newProps.generateOrderErrorTime !== this.props.generateOrderErrorTime) {
            this.props.showError(newProps.generateOrderError);
        }

        if (newProps.managerApprovalTimeStamp !== null && newProps.managerApprovalTimeStamp !== this.props.managerApprovalTimeStamp) {
            if (newProps.managerApprovalSuccess) {
                this.setState({ managerApproved: true })
            } else {
                this.setState({ managerApproved: false })
                this.props.showError(LOOKUP.pos.messages.invalidCredentialsAllowOption);
            }
        }
    }

    componentDidMount() {
        window.addEventListener("keypress", this.barcodeListener);
    }

    barcodeListener = () => {
        if (document.activeElement.tagName != "INPUT") {
            this.barcodeReader.listening(this.getProductByBarcode, 1000);
        }
    }

    getProductByBarcode = (barcode) => {
        this.props.getProductByBarcode(barcode, this.props.branchId);
    }

    cofirmFinish = () => {
        if (this.props.noSalesAllowedAfterStoreHours && ((new Date().getHours()) >= this.props.storeCloseHour || (new Date().getHours()) < this.props.storeOpenHour)) {
            this.props.showError(LOOKUP.pos.messages.orderAfterStoreHours);
            return;
        } else {
            if (this.props.isMedical) {
                this.finishPrepareOnlineOrder();
            } else {
                if (this.state.splitedOnlineOrderProducts && this.state.splitedOnlineOrderProducts.filter(_ => _.scanned == true).length == 0) {
                    if (confirm("You didn't scan any products, are you sure to finish prepare?")) {
                        this.finishPrepareOnlineOrder();
                    }
                }
                else {
                    this.finishPrepareOnlineOrder();
                }
            }
        }
    }

    finishPrepareOnlineOrder = () => {
        let medicalListLots = null;
        if (this.props.isMedical) {
            medicalListLots = this.state.onlineOrderSelected.products.map((item) => {
                return { productId: item.productId, quantity: item.quantity, lotNumber: '' };
            })
        }

        let deviceData = JSON.parse(localStorage.getItem(this.props.deviceKeyName));

        //store to door is inactive
        if (this.state.onlineOrderSelected.deliveryType !== 2) {
            this.props.generateOrderBasedOnlineOrder({
                onlineOrderId: this.state.onlineOrderSelected.id,
                employeeId: this.props.employeeId,
                deviceId: deviceData.id,
                products: (medicalListLots) ? medicalListLots : this.state.splitedOnlineOrderProducts
            });
        }
        else {
            let pickupDate = this.props.selectedPickupDate ? moment(this.props.selectedPickupDate).format("YYYY-MM-DD") : moment().add('day').format('YYYY-MM-DD');
            this.props.generateOrderBasedOnlineOrder({
                onlineOrderId: this.state.onlineOrderSelected.id,
                employeeId: this.props.employeeId,
                deviceId: deviceData.id,
                products: (medicalListLots) ? medicalListLots : this.state.splitedOnlineOrderProducts,
                storeToDoorPickupID: +this.props.selectedPickupTime,
                storeToDoorPickupDate: pickupDate
            });
        }
    }

    goBackPOSPage = () => {
        this.props.navigate("/pos");
        window.location.reload();
    }

    updateProductToScanned = (value, name) => {
        let splitedOnlineOrderProductsCopy = [...this.state.splitedOnlineOrderProducts];
        if (value) {
            let indexInOrderProducts = name.split('_')[1];
            splitedOnlineOrderProductsCopy[indexInOrderProducts].lotNumber = value;
            splitedOnlineOrderProductsCopy[indexInOrderProducts].scanned = true;
        }
        this.setState({
            splitedOnlineOrderProducts: splitedOnlineOrderProductsCopy
        });
    }

    mapStoreToDoorPickupTime() {
        let storetodoorPickupTime = this.props.storetodoorPickupTimes;
        let pickupTimes = [];
        {
            storetodoorPickupTime && storetodoorPickupTime.map(item => {
                pickupTimes.push({
                    text: item.pickupTitle,
                    value: item.pickupID.toString()
                });
            });
        }
        return pickupTimes;
    }

    hourToTime(hour) {
        return new Date(hour * 3600 * 1000).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true, timeZone: 'UTC' });
    }

    openManagerApproval = () => {
        this.setState({ managerApprovalDialogOpened: true })
    }

    closeManagerApproval = () => {
        this.setState({ managerApprovalDialogOpened: false })

        this.props.clearFormInput("FulfillmentApprovalUsername")
        this.props.clearFormInput("FulfillmentApprovalPassword")
        this.props.clearFormInput("FulfillmentApprovalPinCode")
    }

    confirmManagerApproval = () => {
        let validators = [];

        if (!this.props.fulfillmentApprovalPinCode) {
            validators = [
                ["FulfillmentApprovalUsername", d => (d.UserName && d.UserName !== ""), "Username"],
                ["FulfillmentApprovalPassword", d => (d.Password && d.Password !== ""), "Password"]
            ];
        }

        let model = {
            UserName: this.props.fulfillmentApprovalUsername,
            Password: this.props.fulfillmentApprovalPassword,
            PinCode: this.props.fulfillmentApprovalPinCode,
            ApprovalType: "FulfillmentScan"
        };

        if (util.validate(validators, model, this.props.formError)) {
            // this can be replaced to verifyCredential
            this.props.getManagerApproval(model);
            this.closeManagerApproval();
        }
    }

    checkAllProductsScanned = () => {
        let isAllScanned = this.state.splitedOnlineOrderProducts.filter(item => item.isCannabis).every((item) => item.scanned);
        return !isAllScanned;
    }

    changePickupDate = (value) => {
        this.props.getStoreToDoorPickupTime(this.props.branchId, moment(value).format('YYYY-MM-DD'));
    }

    render() {
        let onlineOrderSelected = this.state.onlineOrderSelected;
        let onlineOrderText = this.props.fulfillmentEnabled ? "Queued Order" : "Online Order";
        const time = onlineOrderSelected && onlineOrderSelected.preferredDeliveryTime ? this.hourToTime(onlineOrderSelected.preferredDeliveryTime) : null;
        const comment = onlineOrderSelected && onlineOrderSelected.comment && onlineOrderSelected.comment.split(';')[1];
        let s2dpickupTimes = onlineOrderSelected && onlineOrderSelected.deliveryType == 2 ? this.mapStoreToDoorPickupTime() : [];
        let allProductsScanned = this.checkAllProductsScanned();

        return (
            <Grid>
                <div className="row m-0 pa-2">
                    <h2 className="pull-center purpleText">Preparing {onlineOrderText}</h2>
                </div>
                <CardSimple className="container-reduced">
                    <div className="row m-0">
                        {
                            (onlineOrderSelected !== null && onlineOrderSelected !== undefined) &&
                            <div className="online-order-container">
                                <p className="online-order-number purpleText">
                                    {LOOKUP.ecommerce.onlineOrders.orderType.filter(i => i.value == onlineOrderSelected.type)[0].text} Order #{onlineOrderSelected.code == 0 ? onlineOrderSelected.buddiNumber : onlineOrderSelected.code}
                                </p>

                                <p className="online-order-info purpleText" style={{ marginTop: '5px' }}>
                                    {onlineOrderSelected.preferredDeliveryTime && <div>Preferred Delivery Time: {time}</div>}

                                </p>
                                <div style={{ marginBottom: '20px' }}>
                                    <span className={"status-online-order status-4"}>Preparing</span>

                                </div>

                                <p className="online-order-info purpleText">
                                    Customer: {onlineOrderSelected.member.toUpperCase()}<br />
                                    Item(s): {onlineOrderSelected.products.length} product(s) | SubTotal: ${onlineOrderSelected.subTotal} | Total: ${onlineOrderSelected.total}<br />
                                    Created on: {onlineOrderSelected.createdDateString}
                                    {onlineOrderSelected.email && <div>Email: {onlineOrderSelected.email}</div>}
                                    {onlineOrderSelected.phone && <div>Phone: {onlineOrderSelected.phone}</div>}
                                    {onlineOrderSelected.lastFourDigits && <div style={{ marginBottom: '15px' }}>Last four digits: {onlineOrderSelected.lastFourDigits}</div>}
                                    {comment && <div style={{ color: 'red' }}> {comment}</div>}
                                    {onlineOrderSelected.forDelivery ? <div className={"status-online-order status-4"}>For Delivery</div> : ""}
                                    {onlineOrderSelected.forDelivery && onlineOrderSelected.deliveryType == 3 ? <div className={"status-online-order status-4"}> Deliver Before: {`${onlineOrderSelected.pickUpDate} ${onlineOrderSelected.pickUpTime}`}</div> : ""}
                                    {onlineOrderSelected.deliverySlot && <div>Delilvery Slot: {onlineOrderSelected.deliverySlot}</div>}
                                    {onlineOrderSelected.expireDate && <div>Expire Date: {onlineOrderSelected.expireDate}</div>}
                                    {(onlineOrderSelected.address || onlineOrderSelected.addressTwo) && <div className={"status-online-order status-3"}>Address: {`${onlineOrderSelected.address} ${onlineOrderSelected.addressTwo ? onlineOrderSelected.addressTwo : ''}, ${onlineOrderSelected.city}, ${onlineOrderSelected.state ? onlineOrderSelected.state : ''}, ${onlineOrderSelected.postalCode}`}</div>}
                                    {onlineOrderSelected.deliveryType == 2 ?
                                        <div className="searchBarContainer">
                                            <div className={"status-online-order status-2"}>Delivery Service: StoreToDoor Pickup Time</div>
                                            <table width={"100%"}>
                                                <tr><td>
                                                    <DatePickerInput
                                                        name={"StoreToDoorPickupDate"}
                                                        label={"Pickup Date"}
                                                        fullWidth={true}
                                                        onChange={this.changePickupDate}
                                                    />
                                                </td></tr>
                                                <tr><td>
                                                    <SelectInput
                                                        name={"StoreToDoorPickupTime"}
                                                        fullWidth={true}
                                                        label={"StoreToDoor Pickup Time*"}
                                                        hintText={"StoreToDoor Pickup Time*"}
                                                        options={s2dpickupTimes && s2dpickupTimes.length > 0 ? s2dpickupTimes : []}
                                                    />
                                                </td></tr>
                                            </table>
                                        </div>
                                        : ''
                                    }

                                </p>

                                <hr />

                                {
                                    (this.props.isMedical) ?
                                        <p className="title-products purpleText">Products List</p>
                                        :
                                        <p className="title-products purpleText">Scan the following Products</p>
                                }
                                {this.state.splitedOnlineOrderProducts.map((product, index) => {
                                    return (
                                        <div key={index} className="row item-product-online-order">
                                            <div className={(product.scanned == true) ? "col-lg-8 col-sm-8 col-xs-12 col-md-8 pull-left product-scanned purpleText" : "col-lg-8 col-sm-8 col-xs-12 col-md-8 pull-left purpleText"}>
                                                {product.product} | {product.quantity} x ${product.price.toFixed(2)} = ${product.price.toFixed(2)}
                                                {product.ExistMoreThanOneLotNumbers.length > 0 && product.scanned != true && product.isCannabis ?
                                                    <SelectInputQueuedOrderPrepare name={`queuedOrderProduct_${index}`}
                                                        underlineShow={true}
                                                        options={product.ExistMoreThanOneLotNumbers}
                                                        updateProductToScanned={this.updateProductToScanned}
                                                        defaultValue="0"
                                                        disabled={this.props.settings.fulfillmentScanManagerApproval && !this.state.managerApproved}
                                                    />
                                                    : ''}
                                            </div>
                                            <div className="col-lg-4 col-sm-4 col-xs-12 col-md-4 pull-right">
                                                {
                                                    (product.scanned == true) ?
                                                        <span className="scan-label lot purpleText">Lot #{product.lotNumber}</span>
                                                        : (this.props.isMedical || !product.isCannabis) ?
                                                            <span className="scan-label lot purpleText">Scan is not required</span>
                                                            :
                                                            <span className="scan-label purpleText">Please Scan</span>
                                                }
                                            </div>
                                        </div>
                                    )
                                })}

                                <DialogInput
                                    title={<DialogHeaderWithClose text="Manager Approval" handleClose={() => this.closeManagerApproval()} />}
                                    modal={true}
                                    open={this.state.managerApprovalDialogOpened}
                                    autoScrollBodyContent={true}
                                    actions={[
                                        <Button
                                            key={2}
                                            type="CancelButton"
                                            name="buttonCancel"
                                            className="btn-space"
                                            label={LOOKUP.common.cancel.text}
                                            onTouchTap={() => this.closeManagerApproval()} />,
                                        <Button
                                            key={1}
                                            name="addButton"
                                            label="confirm"
                                            primary={true}
                                            className="btnNewBrandPOS"
                                            onTouchTap={() => this.confirmManagerApproval()} />
                                    ]}>
                                    <div>
                                        {
                                            this.props.settings.fulfillmentScanManagerApproval ?
                                                <div className="row">
                                                    <br />
                                                    <div className="alert alert-danger">
                                                        <p>{LOOKUP.pos.messages.fulfillmentManagerApprovalMessage}</p>
                                                    </div>
                                                    <h4 className="credential_title">{LOOKUP.pos.applyRefundDialog.credentialsTitle}</h4>
                                                    <div className="row">
                                                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                            <TextInput name={`FulfillmentApprovalUsername`}
                                                                fullWidth={true}
                                                                label={LOOKUP.pos.applyRefundDialog.userName.label}
                                                                floatingLabelText={LOOKUP.pos.applyRefundDialog.userName.label}
                                                                hintText={LOOKUP.pos.applyRefundDialog.userName.hintText} />
                                                        </div>
                                                        <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                                            <TextInput name={`FulfillmentApprovalPassword`}
                                                                type="password"
                                                                fullWidth={true}
                                                                label={LOOKUP.pos.applyRefundDialog.password.label}
                                                                floatingLabelText={LOOKUP.pos.applyRefundDialog.password.label}
                                                                hintText={LOOKUP.pos.applyRefundDialog.password.hintText}
                                                                maxLength={30} />
                                                        </div>
                                                    </div> {/* .row */}
                                                    <div>
                                                        <h4>Or By {LOOKUP.pos.applyRefundDialog.pincodeTitle}</h4>
                                                        <div className="row">
                                                            <div className="col-lg-12">
                                                                <TextInput name={`FulfillmentApprovalPinCode`} hintText="Password" fullWidth={true} type="password" maxLength={4} autoComplete="off" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                : ""
                                        }
                                    </div>
                                </DialogInput>

                                {this.props.settings.fulfillmentScanManagerApproval &&
                                    <div className="row m-0">
                                        <div className="col-lg-12">
                                        <Button
                                            name="searchButton"
                                            className="pull-left btnNewBrandPOS"
                                            label={`Allow Select Lot #`}
                                            primary={true}
                                            onTouchTap={() => this.openManagerApproval()}
                                        />
                                        </div>
                                    </div>
                                }

                                <br />
                                <div className="btn-finish-online-order row m-0">
                                    <div className="col-lg-6">
                                    <Button
                                        type="CancelButton"
                                        name="buttonCancel"
                                        className="pull-left purpleText"
                                        label="GO BACK TO POS PAGE"
                                        secondary={true}
                                        onTouchTap={() => this.goBackPOSPage()}
                                    />
                                    </div>
                                    <div className="col-lg-6">
                                        <Button
                                            name="searchButton"
                                            className="pull-right btnNewBrandPOS"
                                            label={`Finish ${onlineOrderText}`}
                                            primary={true}
                                            onTouchTap={() => this.cofirmFinish()}
                                            disabled={this.props.settings.fulfillmentMustScanAllForComplete && allProductsScanned}
                                        />
                                    </div>    
                                </div>
                            </div>
                        }
                    </div>
                </CardSimple>
            </Grid>
        );
    }
}



function mapStateToProps(state) {
    return {
        branchId: state.common.branchId,
        settings: state.common.applicationSettings,
        deviceKeyName: state.common.applicationSettings.deviceKeyName,
        onlineOrders: state.entity.onlineOrders,
        onlineOrderSelected: state.entity.onlineOrder,
        productScan: state.entity.productDetail,
        scannedTime: state.entity.scannedTime,
        generatedOrderId: state.entity.generatedOrderId,
        barcodeNotFound: state.entity.barcodeNotFound,
        isMedical: state.common.applicationSettings.isMedical,
        fulfillmentEnabled: state.common.applicationSettings.fulfillmentEnabled,
        employeeId: state.entity.pin ? state.entity.pin.employee ? state.entity.pin.employee.id : 0 : 0,
        generateOrderErrorTime: state.entity.generateOrderErrorTime,
        generateOrderError: state.entity.generateOrderError,
        storetodoorPickupTimes: state.entity.storetodoorPickupTimes,
        selectedPickupTime: state.form.StoreToDoorPickupTime,
        selectedPickupDate: state.form['StoreToDoorPickupDate'],
        noSalesAllowedAfterStoreHours: state.common.applicationSettings.noSalesAllowedAfterStoreHours,
        storeOpenHour: state.common.applicationSettings.storeOpenHour,
        storeCloseHour: state.common.applicationSettings.storeCloseHour,
        fulfillmentApprovalUsername: state.form['FulfillmentApprovalUsername'],
        fulfillmentApprovalPassword: state.form['FulfillmentApprovalPassword'],
        fulfillmentApprovalPinCode: state.form['FulfillmentApprovalPinCode'],
        managerApprovalTimeStamp: state.entity.managerApprovalTimeStamp,
        managerApprovalSuccess: state.entity.managerApprovalSuccess
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getOnlineOrderDetails: (orderId) => dispatch(getOnlineOrderDetails(orderId)),
        showError: (message) => dispatch(showError(message)),
        getProductByBarcode: (barcode, branchId) => dispatch(getProductByBarcode(barcode, branchId)),
        generateOrderBasedOnlineOrder: (model) => dispatch(generateOrderBasedOnlineOrder(model)),
        getStoreToDoorPickupTime: (branchId, pickupDate) => dispatch(getStoreToDoorPickupTime(branchId, pickupDate)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        formError: (name, error) => dispatch(formError(name, error)),
        getManagerApproval: (model) => dispatch(getManagerApproval(model)),
        formInput: (value, name) => dispatch(formInput(value, name))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(OnlineOrderPrepare));